
      import API from "!../js/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../js/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../js/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../js/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../js/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../js/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../js/node_modules/css-loader/dist/cjs.js!./tiptap.editor.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../js/node_modules/css-loader/dist/cjs.js!./tiptap.editor.css";
       export default content && content.locals ? content.locals : undefined;
